const paths = {
  index: (propertyDealId: number) =>
    `${process.env.NEXT_PUBLIC_API_HOST}/api/property_deals/${propertyDealId}/deal_estimation_files`
} as const;

export const getDownloadPath = (propertyDealId: number): string =>
  paths.index(propertyDealId);
